import {GetProp,  Alert, Avatar, Button, Card, Col, Divider, Form, InputNumber, Row, Select, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import {
  CheckOutlined,
  CloseOutlined,
  CreditCardOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { ITransaction } from '../../../interfaces/transactions';
import { getProperDate } from '../../../utils/date';
import { TransactionHelper } from '../../transactions/helper/transactions.helper';
import { SIGN_BY_TYPE_OF_TRANSACTION } from '../../transactions';
import TransactionStateTag from '../../transactions/components/transaction-state-tag';
import { IssuersBrands } from '../../../utils/IssuersBrands';
import { useAppContext } from '../../../context/appContext';
import Upload, { UploadChangeParam } from 'antd/es/upload';
import useAuthService from '../../../hooks/useAuthService';
import usePostRequestUpgrade from '../../../hooks/utils/usePostRequestUpgrade';
import { validateStatus } from '../../../utils/utils';
import useToastContext from '../../../hooks/useToastContext';
import { FirstStepFormInputs, SecondStepFormInputs, ThirdStepFormInputs } from '../claim-new';
import { UploadFile, UploadProps } from 'antd/lib/upload';
import { InboxOutlined } from '@ant-design/icons';
import { claim_brand_reasons } from '../const/claim_brand_reasons';
import { ClaimReasonDTO } from '../dto/claim_reason.dto';
import AuthorizationAmountView from './authorization-amount-view';
import { useNavigate } from 'react-router-dom';
import useUploadImporterFile from 'hooks/useUploadImporter';
import { useLoading } from '../../../context/LoadingContext';

const { Dragger } = Upload;
type FileType = Parameters<GetProp<UploadProps, 'beforeUpload'>>[0];

type TxnMapValue = {
  type: "TOTAL";
  amount: number | undefined;
};

type FourthStepProps = {
  goToPrevious?: () => void | null;
  firstStepData?: FirstStepFormInputs | null;
  secondStepData?: SecondStepFormInputs | null;
  thirdStepData?: ThirdStepFormInputs | null;
};

const FourthStep: React.FC<FourthStepProps>  =  ({
  goToPrevious,
  firstStepData,
  secondStepData,
  thirdStepData,
}) => {
  const {
    settings: { issuer },
  } = useAppContext();
  const navigate = useNavigate();
  const { userInfo, userHasRole } = useAuthService();
  const toast = useToastContext();
  const [claimReason, setClaimReason] = useState<ClaimReasonDTO>();
  const [formData, setFormData] = useState({});
  const { executePost: execute, postLoading: loading, postError: error  } = usePostRequestUpgrade({ path: 'v1/claims' });
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const { upload: uploadFile, isLoading } = useUploadImporterFile()
  const { setLoading, setSuccess, setErrors } = useLoading();


  const brand = IssuersBrands["VISA"].includes(issuer?.name?.toUpperCase()) ? "VISA" : "MASTERCARD"

  const reasonsByNetwork = claim_brand_reasons.filter(r => r.network === brand);

  const reasonsOptions = reasonsByNetwork.map((item, index) => ({
    label: item.reason,
    value: index
  }));

  const handleReasonChange = (index: number) => {
    setClaimReason(reasonsByNetwork[index])
    console.log(reasonsByNetwork[index])
  };

  const handleSelectChange = (value, id, txAmount) => {
    setFormData((prev) => ({
      ...prev,
      [id]: { type: value, amount: value === "TOTAL" ? txAmount : prev[id]?.amount},
    }));
  };

  const handleAmountChange = (value, id) => {
    setFormData((prev) => ({
      ...prev,
      [id]: { ...prev[id], amount: value },
    }));
  };

  const getDateByTransactionType = (transaction: ITransaction) => {
    return getProperDate(transaction?.authorization?.info?.transaction?.received_timestamp)?.concat('hs')
  }

  const getAmountColor = (transaction: ITransaction) => {
    let color = '#000000'

    if(transaction?.authorization?.approved || transaction?.authorization?.irc === '8444'){
      color = SIGN_BY_TYPE_OF_TRANSACTION.get(transaction.authorization.info.transaction.type) === '+' ? '#52c41a' : '#ff4d4f'
    }
    return color
  }

  const getIcon = (transaction: ITransaction) => {
    let color = <CheckOutlined />

    if(transaction?.authorization?.approved || transaction?.authorization?.irc === '8444'){
      color = SIGN_BY_TYPE_OF_TRANSACTION.get(transaction.authorization.info.transaction.type) === '+' ? <CheckOutlined /> : <CloseOutlined />
    }
    return color
  }

  function getIdentification(firstStepData) {
    return firstStepData?.identifications?.filter(
      (identification) =>
        identification?.type === 'CUIL' || identification?.type === 'CUIT' || identification?.type === 'DNI'
    )?.[0]?.number ?? 'No registra identificacion.'
  }

  function capitalizeFirstLetter(str) {
    return str?.charAt(0)?.toUpperCase() + str?.slice(1);
  }

  const mapTransactions = (thirdStepData: ITransaction[], formData) => {
    return thirdStepData?.map(txn => {
      const txnId = txn.authorization.info.transaction.id;
      const formDataTxn = formData[txnId] || {};
      return {
        amount: formDataTxn?.type === "TOTAL" ? txn?.authorization?.info?.amounts?.original?.amount : formDataTxn?.amount,
        claim_type: formDataTxn?.type,
        date: txn?.authorization?.info?.transaction?.received_timestamp?.concat("Z"),
        rrn: txnId,
      };
    });
  };

  const handleCreateClaim = async () => {
    if(claimReason.need_file){
      const file = fileList[0]
      const formData = new FormData();
      formData.append('file', file as FileType);

      try {
        const res = await uploadFile( "CLAIMS_LOAD" , formData);
        if (validateStatus(res?.status)) {
          toast.success('Archivo subido', `El archivo se subio correctamente`);
          submitClaim([res.data.filename])
        } else {
          throw new Error('Hubo en error al subir el archivo.');
        }
      } catch (e) {
        console.error(e);
        toast.error('Algo Salio mal', 'Hubo en error al subir el archivo.');
      }
    }else{
      submitClaim([])
    }
  }


 const submitClaim = async (attachments: string[]) => {
    try {
      setLoading(true);
      const response = await execute({ data: {
          attachments_file_names: attachments,
          card_id: secondStepData?.card?.card_id,
          cardholder_id: firstStepData?.cardHolder.id,
          dispute_reason: claimReason.dispute_reason,
          reason_code: claimReason.code,
          transactions: mapTransactions(thirdStepData.transaction, formData),
          username: userInfo.name
        } });
      setLoading(false);

      if(validateStatus(response?.status)) {
        setSuccess({title:"Reclamo generado correctamente!", extraButtons: [
            // @ts-ignore
            <Button type="primary" key="cardholder" onClick={() => navigate(`/${issuer?.name}/claims/${response?.data?.id}`)}>
              Ver
            </Button>,
            <Button key="continue" onClick={() => navigate(`/${issuer?.name}/claims`)}>Continuar</Button>
          ]})
      }

    } catch(err) {
      setLoading(false);
      toast.error('Error', `Ocurrió un error al crear el reclamo: ${err}.`);
    }
 }



  const props: UploadProps = {
    name: 'file',
    multiple: false,
    beforeUpload: (file) => {
      setFileList([...fileList, file]);

      return false;
    },
    fileList,
  };



  useEffect(() => {
    if (!thirdStepData?.transaction) return;
  
    const initialData: Record<string, { type: string; amount: number | null }> = {};
  
    thirdStepData.transaction.forEach((txn) => {
      const id = txn?.authorization?.info?.transaction?.id;
      const amount = txn?.authorization?.info?.amounts?.original?.amount;
  
      if (id) {
        initialData[id] = {
          type: "TOTAL",
          amount: amount,
        };
      }
    });
  
    setFormData(initialData); // set once instead of in loop
  }, [thirdStepData]);
  


  return (
    <div>
      <Typography.Title level={2}>Resumen</Typography.Title>
      <Row gutter={24}>
        <Col span={7}>
          <Card
            title="Titular"
            variant="borderless"
            style={{
              boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
              transform: "translateY(-2px)",
              transition: "all 0.3s ease",
              minHeight: '170px',
              maxHeight: '170px'
            }}
          >
            <Row gutter={24}>
              <Col span={3}>
                <Avatar style={{ backgroundColor: 'rgb(163, 104, 252)', color: 'white' }} size="large" icon={<UserOutlined />} />
              </Col>
              <Col span={12} style={{ display: 'flex', flexDirection: 'column' }}>
                <Typography.Text type="secondary">Nombre</Typography.Text>
                <Typography.Text style={{ margin: '5px' }}>{capitalizeFirstLetter(firstStepData?.cardHolder.first_name)} {capitalizeFirstLetter(firstStepData?.cardHolder.last_name)}</Typography.Text>
              </Col>
              <Col span={9} style={{ display: 'flex', flexDirection: 'column'}}>
                <Typography.Text type="secondary">Identificación</Typography.Text>
                <Typography.Text style={{ alignItems: 'center', margin: '5px' }}>{getIdentification(firstStepData)}</Typography.Text>
              </Col>
            </Row>
          </Card>
        </Col>
        <Col span={17}>
          <Card
            title="Tarjeta"
            variant="borderless"
            style={{
              boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
              transform: "translateY(-2px)",
              transition: "all 0.3s ease",
              minHeight: '170px',
              maxHeight: '170px'
            }}>
            <Row gutter={24}>
              <Col span={2}>
                <Avatar style={{ backgroundColor: 'rgb(163, 104, 252)', color: 'white' }} size="large" icon={<CreditCardOutlined />} />
              </Col>
              <Col span={10} style={{ display: 'flex', flexDirection: 'column' }}>
                <Typography.Text type="secondary">ID</Typography.Text>
                <Typography.Text style={{ margin: '5px' }}>{secondStepData?.card?.card_id}</Typography.Text>
              </Col>
              <Col span={5} style={{ display: 'flex', flexDirection: 'column' }}>
                <Typography.Text type="secondary">Fecha</Typography.Text>
                <Typography.Text style={{ margin: '5px' }}>{secondStepData.card.created_time}</Typography.Text>
              </Col>
              <Col span={2} style={{ display: 'flex', flexDirection: 'column' }}>
                <Typography.Text type="secondary">Últ 4</Typography.Text>
                <Typography.Text style={{ margin: '5px' }}>{secondStepData?.card.last_four}</Typography.Text>
              </Col>
              <Col span={2} style={{ display: 'flex', flexDirection: 'column' }}>
                <Typography.Text type="secondary">Owner</Typography.Text>
                <Typography.Text style={{ margin: '5px' }}>{secondStepData?.card.ownership_level}</Typography.Text>
              </Col>
              <Col span={3} style={{ display: 'flex', flexDirection: 'column' }}>
                <Typography.Text type="secondary">Estado</Typography.Text>
                <Typography.Text style={{ margin: '5px' }}>{secondStepData?.card.state}</Typography.Text>
              </Col>
            </Row>
          </Card>
        </Col>
        <Col span={24} style={{  marginTop: '10px' }}>
          <Card
            title="Motivo"
            variant="borderless"
            style={{
              boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
              transform: "translateY(-2px)",
              transition: "all 0.3s ease",
              display: 'flex',
              flexDirection: 'column',
              height: '205px',
              maxHeight: '205px'
            }}
          >
            <Typography.Text type="secondary">Seleccione el motivo del reclamo</Typography.Text>
            <Select
              style={{ width: '100%' }}
              placeholder="Seleccionar"
              options={reasonsOptions}
              onChange={handleReasonChange}
            />

          </Card>
        </Col>
        <Col span={24} style={{ marginTop: '10px' }}>
          <Card
            title="Transacciones"
            variant="borderless"
            style={{
              boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
              display: 'flex',
              flexDirection: 'column',
            }}
          >
                {
                  thirdStepData?.transaction.map( (txn) => (
                  <Row gutter={24} key={txn?.authorization?.info?.transaction?.id}>
                    <Col span={1} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
                      <Avatar style={{ backgroundColor: getAmountColor(txn), color: 'white' }} size="small" icon={getIcon(txn)} />
                    </Col>
                    <Col span={4} style={{ display: 'flex', flexDirection: 'column' }}>
                      <Typography.Text type="secondary">Fecha</Typography.Text>
                      <Typography.Text style={{ margin: '5px' }}>{getDateByTransactionType(txn)}</Typography.Text>
                    </Col>
                    <Col span={4} style={{ display: 'flex', flexDirection: 'column' }}>
                      <Typography.Text type="secondary">Descripción</Typography.Text>
                      <Typography.Text style={{ margin: '5px' }}>
                        {TransactionHelper.getMerchant(txn.authorization.info.transaction.type, txn.authorization.info.merchant.name)}
                      </Typography.Text>
                    </Col>
                    <Col span={3} style={{ display: 'flex', flexDirection: 'column' }}>
                      <Typography.Text type="secondary">Monto</Typography.Text>
                      <AuthorizationAmountView authorization={ txn?.authorization } />
                    </Col>
                    <Col span={3} style={{ display: 'flex', flexDirection: 'column' }}>
                      <Typography.Text type="secondary">Tipo</Typography.Text>
                      <Typography.Text style={{ margin: '5px' }}>{TransactionHelper.getTransactionType(txn.authorization.info.transaction.type)}</Typography.Text>
                    </Col>
                    <Col span={2} style={{ display: 'flex', flexDirection: 'column' }}>
                      <Typography.Text type="secondary">Estado</Typography.Text>
                      <TransactionStateTag
                        approved={txn?.authorization?.approved}
                        irc={ txn?.authorization?.irc}
                        style={{ marginTop: '5px'}}
                      />
                    </Col>
                    <Col span={3} style={{ display: 'flex', flexDirection: 'column' }}>
                      <Typography.Text type="secondary">Mensaje</Typography.Text>
                      <Typography.Text style={{ margin: '5px' }}>
                        {
                          !txn?.authorization?.approved || txn?.authorization?.irc !== '8444'
                            ? txn?.authorization?.info?.transaction?.display_message
                            : ''
                        }
                      </Typography.Text>
                    </Col>
                    <Col span={3} style={{ display: 'flex', flexDirection: 'column' }}>
                      <Typography.Text type="secondary">Ubicación</Typography.Text>
                      <Typography.Text style={{ margin: '5px' }}>{txn?.authorization.info.merchant.country?.concat(" " + txn?.authorization.info.merchant.city)}</Typography.Text>
                    </Col>
                    <Col span={24} style={{ display: 'flex', flexDirection: 'column' }}>
                      <Divider orientation="left" orientationMargin="0">Reclamo </Divider>
                      <Row>
                        <Col span={4}>
                          <Typography.Text type="secondary">Tipo</Typography.Text>
                            <Select
                              style={{ width: '95%'}}
                              placeholder="Seleccionar"
                              options={[
                                { label: "TOTAL", value: "TOTAL" },
                                { label: "PARCIAL", value: "PARTIAL" },
                              ]}
                              value={formData[txn?.authorization?.info?.transaction?.id]?.type || undefined}
                              onChange={(value) => handleSelectChange(value, txn?.authorization?.info?.transaction?.id,  txn?.authorization?.info?.amounts?.original?.amount)}
                            />
                        </Col>
                        <Col span={4}>
                          <Typography.Text type="secondary">Monto</Typography.Text>
                            <InputNumber
                              style={{ width: "100%" }}
                              min={1}
                              value={formData[txn?.authorization?.info?.transaction?.id]?.amount || undefined}
                              onChange={(value) => handleAmountChange(value, txn?.authorization?.info?.transaction?.id)}
                              disabled={formData[txn?.authorization?.info?.transaction?.id]?.type !== "PARTIAL"}
                            />
                        </Col>
                      </Row>
                      </Col>
                    <Divider />
                  </Row>
                  ))
                }
          </Card>
        </Col>

        { claimReason != null && claimReason.need_file === true &&
            <Col span={24} style={{ marginTop: '10px'}}>
              <Card
                title="Adjuntos"
                variant="borderless"
                style={{
                  boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <Row gutter={24} >
                  <Col span={24}>                 
                    <div style={{ margin: '10px'}}>
                    <Dragger {...props}>
                        <p className="ant-upload-drag-icon">
                          <InboxOutlined />
                        </p>
                        <p className="ant-upload-text">Hace click o arrastrá los archivos a esta area. </p>
                      </Dragger>
                    </div>
                  </Col>
                </Row>   
              </Card>
            </Col>
        }
      </Row>

      { claimReason != null && claimReason.category === "1 - Disputas de Fraude" && secondStepData?.card.state != "BLOCKED" && 

        <Alert
          message="Estado de Tarjeta"
          description="La tarjeta no está bloqueada, en el caso de continuar con la creación del reclamo se deberá bloquear la misma."
          type="info"
          showIcon
        />

      }



      <div style={{ textAlign: 'center', maxWidth: '100%', marginTop: '10px' }}>
        <Button onClick={goToPrevious} type="primary">
          Anterior
        </Button>
        <Button
          disabled={claimReason === undefined}
          onClick={handleCreateClaim}
          type="primary"
          style={{ left: '10px' }}
          loading={loading}
        >
          Crear
        </Button>
      </div>
    </div>
  )
}

export default FourthStep;